export const DEFAULT_VISIBLE_SUBSCRIPTIONS = 5;
